import * as React from 'react';

import UserInfo from '../../interfaces/UserInfo';

interface Props {
  tableHeadItem: string;
  firstUserInfoItem: UserInfo;
}

function PersonalItem (props: Props) {
  const { tableHeadItem, firstUserInfoItem } = props;
  return (
    <div
      className='d-flex border-row'>
      <div
        className='personal-title bold'>
        {tableHeadItem[0].toUpperCase() + tableHeadItem.slice(1).split('_').join(' ')}
      </div>
      <div className='personal-text'>{firstUserInfoItem[tableHeadItem]}</div>
    </div>
  );
}

export default React.memo(PersonalItem);
